import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Domestic = () => {
    const [locations, setLocations] = useState([]);

    useEffect(() => {
        import('../../../Data/Domestic/FeaturedDestination').then((module) => {
            setLocations(module.default);
        });
    }, []);

    return (
        <div className='mt-44 mb-20'>
            <motion.h2
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="text-4xl font-extrabold text-center text-yellow-700 mb-12 mt-20 p-1"
            >
            Domestic Tour Packages
            </motion.h2>
            <div className="flex flex-wrap justify-center items-center m-auto px-4">
                {locations.map((loc, index) => (
                    <motion.div
                        key={loc.id || index}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: index * 0.1 }}
                        viewport={{ once: true }}
                        className="w-full sm:w-72 md:w-80 lg:w-96 m-4 bg-white/40 backdrop-blur-md border border-white/20 rounded-3xl shadow-md hover:shadow-lg transition-transform transform hover:scale-105 overflow-hidden"
                    >
                        <div className="h-48 overflow-hidden">
                            <img
                                src={loc.images[0]}
                                alt={loc.title}
                                className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                            />
                        </div>
                        <div className="p-5">
                            <h3 className="text-xl font-bold text-yellow-800">{loc.title}</h3>
                            <p className="text-sm text-gray-600 mt-2">{loc.description}</p>
                            <p className="text-yellow-600 font-medium mt-2">{loc.tripDuration}</p>
                            <Link
                                to={`/domestic/${loc.id}`}
                                className="inline-block mt-4 bg-gradient-to-r from-yellow-400 to-yellow-500 text-white px-5 py-2 rounded-full shadow-md hover:shadow-lg transition duration-300"
                            >
                                View More
                            </Link>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default Domestic;
